import React from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { Query, useMutation, useQuery } from 'react-apollo';
import StudentLCCalendar from '../../lead/Meeting';
import StudentHCCalendar from '../../head/Meeting';
import FACalendar from '../../fa_coach/Meeting';
import StudentLCCalendarCircle from '../../lead/CircleMeeting';
import StudentHCCalendarCircle from '../../head/CircleMeeting';
import FAFSAMeeting from '../../fa_coach/FAFSAmeeting';
import CSSProfileMeeting from '../../fa_coach/CSSProfileMeeting';
import CSSandFAFSAMeeting from '../../fa_coach/CSSandFAFSA';
import { UPDATE_MILESTONE_EXERCISE_AND_STATUS } from 'graphql/student/milestones';
import { ROLES } from 'constant/userTypes';
import { GET_STUDENT_PROFILE } from 'graphql/student/Profile';
import { LinearProgress } from '@material-ui/core';
import PRODUCTS from 'constant/product-types';
import { GET_STUDENT_CREDITS } from 'graphql/credits';

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

const ScheduleMeeting = ({
  type,
  milestoneExercise,
  reschedule,
  studentName,
  studentEmail,
  lc_id,
  hc_id,
  fa_id,
  group,
  onClose,
  milestoneId,
  milestoneStatus,
  studentId,
  student,
}) => {
  const [updateTask] = useMutation(UPDATE_MILESTONE_EXERCISE_AND_STATUS);
  const user = useSelector((state) => state.user.user);
  const { data: creditsResp } = useQuery(GET_STUDENT_CREDITS, {
    variables: { userId: studentId },
    fetchPolicy: 'network-only',
  });

  const usage = creditsResp?.usage;

  const circle_cc_total = usage?.find((i) => i.credit_type === 'circle_cc')?.available || 0;
  const circle_cc_done = Math.abs(usage?.find((i) => i.credit_type === 'circle_cc')?.debit) || 0;

  let cc_total = usage?.find((i) => i.credit_type === 'cc')?.available || 0;
  let cc_done = Math.abs(usage?.find((i) => i.credit_type === 'cc')?.debit || 0);
  let cc_circleCc_total = cc_total + circle_cc_total; // total available value of CC and circle_cc
  let cc_CircleCc_done = cc_done + circle_cc_done;  //total debit value of CC and circle_cc 




  const circle_hc_total = usage?.find((i) => i.credit_type === 'circle_hc')?.available || 0;
  const circle_hc_done = Math.abs(usage?.find((i) => i.credit_type === 'circle_hc')?.debit) || 0;

  const hc_total = usage?.find((i) => i.credit_type === 'hc')?.available || 0;
  const hc_done = Math.abs(usage?.find((i) => i.credit_type === 'hc')?.debit || 0);
  let hc_circleHc_total = hc_total + circle_hc_total; // total available value of HC and circle_HC
  let hc_circleHc_done = hc_done + circle_hc_done;  //total debit value of HC and circle_HC 


  const fa_total = usage?.find((i) => i.credit_type === 'fa')?.available || 0;
  const fa_done = Math.abs(usage?.find((i) => i.credit_type === 'fa')?.debit || 0,);
  
  
  const fafsa_total =usage?.find((i) => i.credit_type === 'fafsa')?.available || 0;
  const fafsa_done = Math.abs(usage?.find((i) => i.credit_type === 'fafsa')?.debit || 0,);
  
  
  const cssp_total =usage?.find((i) => i.credit_type === 'css_profile')?.available || 0;
  const cssp_done = Math.abs(usage?.find((i) => i.credit_type === 'css_profile')?.debit || 0,);
  
  
  const fafsaCss_total =usage?.find((i) => i.credit_type === 'fafsa_css')?.available || 0;
  const fafsaCss_done = Math.abs(usage?.find((i) => i.credit_type === 'fafsa_css')?.debit || 0,);
  // const cc_available = cc_total - cc_done;

  
  const cc_available = cc_circleCc_total - cc_CircleCc_done;
  const hc_available = hc_circleHc_total - hc_circleHc_done;
  const fa_available = fa_total - fa_done;
  const fafsa_available = fafsa_total - fafsa_done;
  const cssp_available = cssp_total - cssp_done;
  const fafsaCss_available = fafsaCss_total - fafsaCss_done;

  let props = {
    task: milestoneExercise,
    reschedule,
    student: {
      name: studentName,
      email: studentEmail,
      lc_id,
      hc_id,
      fa_id,
      group,
    },
    onClose: onClose,
    onBookingComplete: (event) => {
      if (!reschedule) {
        window.analytics.track('Meeting Scheduled', {
          id: milestoneExercise.id,
          input: {
            due_date: event.slot.start,
            status: 'inprogress',
            response: {
              sub: user.sub,
              eventId: event.id,
              source: 'cronify',
            },
          },
          milestoneId: milestoneId,
          product: PRODUCTS_LOOKUP[student.product_type],
        });
      } else {
        window.analytics.track('Meeting Rescheduled', {
          id: milestoneExercise.id,
          input: {
            due_date: event.slot.start,
            status: 'inprogress',
            response: {
              sub: user.sub,
              eventId: event.id,
              source: 'cronify',
            },
          },
          milestoneId: milestoneId,
          product: PRODUCTS_LOOKUP[student.product_type],
        });
      }
      return updateTask({
        variables: {
          id: milestoneExercise.id,
          input: {
            due_date: event.slot.start,
            status: 'inprogress',
            response: {
              sub: user.sub,
              eventId: event.id,
              source: 'cronify',
            },
          },
          milestoneId: milestoneId,
          data: {
            status: !milestoneStatus ? 'inprogress' : milestoneStatus,
          },
        },
      });
    },
    allowCustomSlot: user.type !== ROLES.STUDENT,
  };

  if (reschedule) {
    const now = moment.utc(milestoneExercise.due_date);
    const dueInHour = moment
      .tz(milestoneExercise.due_date, user.timezone)
      .diff(moment.utc(), 'h', true);
    const min = now.clone().subtract(2, 'h');
    const max = now.clone().add(2, 'h');
    if (dueInHour < 24 && user.type === ROLES.STUDENT) {
      props.availablePeriods = {
        start: min.format(),
        end: max.format(),
      };
    } else if (user.type !== ROLES.STUDENT) {
      props.availablePeriods = {
        start: moment
          .utc()
          .add(1, 'd')
          .format(),
        end: moment
          .utc()
          .add(30, 'd')
          .format(),
      };
    } else {
      props.availablePeriods = {
        start: moment
          .utc()
          .add(1, 'd')
          .format(),
        end: moment
          .utc()
          .add(30, 'd')
          .format(),
      };
    }
  } else {
    props.availablePeriods = {
      start: moment
        .utc()
        .add(1, 'd')
        .format(),
      end: moment
        .utc()
        .add(30, 'd')
        .format(),
    };
  }

  const prefix = reschedule ? 'Reschedule' : 'Book';





  const renderCal = (props) => {

    if (type === 'cc') {
      return (
        <StudentLCCalendar
          hasCredit={cc_available > 0}
          {...props}
          title={`${prefix} Coaching Session`}
        />
      );
    } else if (type === 'hc') {
      return (
        <StudentHCCalendar
          hasCredit={hc_available > 0}
          student={props.student}
          {...props}
          title={`${prefix} Milestone Meeting`}
        />
      );
    } else if (type === 'fa') {
      return (
        <FACalendar
          hasCredit={fa_available > 0}
          {...props}
          title={`${prefix} Financial Aid Meeting`}
        />
      );
    } else if (type === 'circle_cc') {
      return (
        <StudentLCCalendarCircle
          hasCredit={cc_available > 0}
          {...props}
          title={`${prefix} Coaching Session`}
        />
      );
    } else if (type === 'circle_hc') {
      return (
        <StudentHCCalendarCircle
          hasCredit={hc_available > 0}
          {...props}
          title={`${prefix} Milestone Meeting`}
        />
      );
    } else if (type === 'fafsa') {
      return (
        <FAFSAMeeting
          hasCredit={fafsa_available > 0}
          {...props}
          title={`FAFSA Review Meeting`}
        />
      );
    } else if (type === 'css_profile') {
      return (
        <CSSProfileMeeting
          hasCredit={cssp_available > 0}
          {...props}
          title={`CSS Profile Review Meeting`}
        />
      );
    } else if (type === 'fafsa_css') {
      return (
        <CSSandFAFSAMeeting
          hasCredit={fafsaCss_available > 0}
          {...props}
          title={`FAFSA and CSS Profile Review Meeting`}
        />
      );
    }
  };

  return (
    <Query
      query={GET_STUDENT_PROFILE}
      variables={{
        id: studentId,
      }}
      fetchPolicy={'network-only'}
    >
      {({ loading, data }) => {
        if (loading) return <LinearProgress size={16} />;

        const profile = data?.student_profile[0];
        props = {
          ...props,
          student: {
            ...props.student,
            lc_id: profile?.lc_id,
            hc_id: profile?.hc_id,
            fa_id: profile?.fa_id,
          },
        };

        return <>{renderCal(props)}</>;
      }}
    </Query>
  );
};

export default ScheduleMeeting;
